import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson0DefaultStartCode = `use debug::print;
use debug::PrintTrait;
${doNotModifyCodeAbove}`;

export const lesson0DefaultMiddleCode = `enum Message { // TODO: define a few types of messages as used below
}`;

export const lesson0DefaultEndCode = `${doNotModifyCodeBelow}
fn main() {
    Message::Quit(()).print();
    Message::Echo(()).print();
    Message::Move(()).print();
    Message::ChangeColor(()).print();
}

impl MessagePrintImpl of PrintTrait::<Message> {
    fn print(self: Message) {
        match self {
            Message::Quit(()) => ('Quit').print(),
            Message::Echo(()) => ('Echo').print(),
            Message::Move(()) => ('Move').print(),
            Message::ChangeColor(()) => ('ChangeColor').print()
        }
    }
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
